<div fxLayout="column" class="terms-of-service" MalihuScrollbar [scrollbarOptions]="scrollbarOptions">
    <app-terms></app-terms>
</div>